export default {
  text: "#F5F6FA",
  heading: "#F5F6FA",
  highlight: "#39C881",
  background: "#222F51"
};
